<template>
  <d-modal
    size="lg"
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      Spotkania w dniu: {{ popupTitle }}
    </d-modal-header>
    <d-modal-body>
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" width="110px" class="border-0 align-middle">Godzina</th>
            <th scope="col" class="border-0 align-middle">Klient</th>
            <th scope="col" width="150px" class="border-0 align-middle text-center" style="width: 150px;">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(meeting, index) of currentDayMeetings"
            :key="'meeting-' + index">
            <td>
              {{ meeting.time | formatTime }}
            </td>
            <td>
              {{getClientName(meeting.customer_id)}}
              <br>
              <small style="color: #c4183c;">{{ meeting.important_information }}</small>
              <br>
              <small>{{ meeting.description }}</small>
            </td>
            <td class="text-center align-middle pt-0">
              <d-button
                theme="primary"
                @click.prevent="showEditPopup(meeting)"
                class="mx-2 mt-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.prevent="removeMeeting(meeting.id)"
                class="mx-2 mt-2"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="currentDayMeetings.length === 0">
            <td colspan="3" class="text-center">
              Brak zaplanowanych spotkań w tym dniu.
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        theme="success"
        class="d-block mx-auto"
        @click.prevent="addMeetingToday()">
        <i class="material-icons">add</i>
        Dodaj spotkanie
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>
<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'day-view',
  filters: {
    formatTime (time) {
      let timeArr = time.split(':');
      return timeArr[0] + ':' + timeArr[1]
    },
  },
  computed: {
    popupTitle () {
      return this.curentDate;
    }
  },
  data() {
    return {
      clients: [],
      curentDate: '',
      currentDayMeetings: [],
      isHidden: true,
      removeInProgress: false
    };
  },
  mounted() {
    this.$bus.$on('show-calendar-day-popup', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    openPopup(date, allMeetings = [], clients = []) {
      this.curentDate = date;
      this.clients = clients;
      this.currentDayMeetings = allMeetings.filter(meeting => meeting.date === date);
      this.currentDayMeetings.sort((a, b) => ((new Date('1970/01/01 ' + a.time)) - (new Date('1970/01/01 ' + b.time))));

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
    showEditPopup (meeting) {
      this.handleClose();
      this.$bus.$emit('calendar-add-meeting-popup-show', meeting);
    },
    removeMeeting (meetingId) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/meetings/delete/',
        id: meetingId,
        successTitle: 'Usunięto spotkanie',
        successText: 'Wybrane spotkanie zostało usunięte',
        confirmTitle: 'Czy na pewno chcesz usunąć to spotkanie?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie spotkania nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.currentDayMeetings = this.currentDayMeetings.filter(meeting => meeting.id !== meetingId);
          this.removeInProgress = false;
          this.$bus.$emit('calendar-refresh');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    getClientName (customerID) {
      let assignedCustomer = this.clients.filter(customer => customer.id === customerID);
      return assignedCustomer.length ? (assignedCustomer[0].name + ' ' + assignedCustomer[0].surname) : 'Klient nie został znaleziony w bazie danych.';
    },
    addMeetingToday () {
      this.handleClose();
      this.$bus.$emit('calendar-add-meeting-popup-show', null, this.curentDate)
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-calendar-day-popup', this.openPopup);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
.column-actions {
  max-width: 200px;
}
@media (max-width: 1024px) {
  table.table tbody tr td:nth-child(2){
    padding-bottom: 0!important;
    padding-top: 0!important;
  }
  table.table tbody tr td:first-child {
    padding-bottom: 5px!important;
  }
}
</style>
